import { useState } from 'react';
import { useSelector } from 'react-redux';

import SectionCard from '../../../../components/SectionCard/SectionCard';
import IndividualFormSelection from '../../../StageCreationModal/components/StageAppSelection/IndividualFormSelection';
import StyledWrapper from '../../style';

import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import { useGetFormsBeingReviewedQuery } from '../../../../services/endpoints/formBuilderEndpoints';
import { getLocalAuth } from '../../../../utils/environmentUtils';

const AppForm = ({ isMasterLayout }) => {
	const [expanded, setExpanded] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const [allExpanded, setAllExpanded] = useState(false);

	const accountSource = useSelector((state) => state?.login?.accountSource);
	const apiToken = getLocalAuth(accountSource)?.access_token;
	const path = window.location.pathname;
	const pathSegments = path.split('/');
	const appID = pathSegments.find((segment) => segment.includes('api-'));

	const toReview = useSelector((state) => state?.form?.to_review);

	const list_of_fields = toReview?.map((e) => e?.review_inputs);
	const { data: FormsBeingReviewed, error } = useGetFormsBeingReviewedQuery(
		{
			apiToken,
			payload: {
				application_id: appID?.split('-')[1],
				ids: toReview?.map((e) => e?.formId?.split('-')[1]),
				fields: list_of_fields ? [].concat(...list_of_fields) : []
			}
		},
		// If toReview is empty, no content was marked for review
		{ skip: !toReview || toReview?.length === 0 }
	);

	const handleExpansion = (expandedAccordion) => {
		setAllExpanded(false);

		const expandedFormatted = expanded;
		const existsIndex = expandedFormatted?.indexOf(expandedAccordion);
		existsIndex !== -1
			? expandedFormatted.splice(existsIndex, 1)
			: expandedFormatted.push(expandedAccordion);

		setExpanded(expandedAccordion === '' ? [] : expandedFormatted);
		setRefresh(!refresh);
	};

	return (
		<SectionCard width="100%" height="fit-content" padding="0px" maxHeight="600px" overflowY="auto">
			<StyledWrapper.DetailTitleContainer data-testid={`appForm-title-container`}>
				<StyledWrapper.DetailTitle>Application Forms to Review</StyledWrapper.DetailTitle>
				<StyledWrapper.ActionButtonContainer>
					<StyledWrapper.CustomIconButton onClick={() => setAllExpanded(true)} aria-label="unfold">
						<UnfoldMoreIcon />
					</StyledWrapper.CustomIconButton>
					<StyledWrapper.CustomIconButton onClick={() => handleExpansion('')} aria-label="fold">
						<UnfoldLessIcon />
					</StyledWrapper.CustomIconButton>
				</StyledWrapper.ActionButtonContainer>
			</StyledWrapper.DetailTitleContainer>

			{FormsBeingReviewed?.map((form, index) => (
				<IndividualFormSelection
					key={`individualform-selection-${index}`}
					readOnly={true}
					allExpanded={allExpanded}
					appId={form?.form?.unique_identifier}
					title={form?.form?.label}
					expanded={expanded}
					isReviewing={true}
					isMasterLayout={isMasterLayout}
					handleExpansion={handleExpansion}
					prefetchedValues={form?.field_values || []}
					prefetchedSchema={form?.form_schema || []}
				/>
			))}
		</SectionCard>
	);
};

export default AppForm;
